module.exports = __webpack_public_path__ + "media/flat/verve-bcb2b956.svg";